import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { CTACard } from '../CtaCard';
import { ImageCard } from '../ImageCard';
import { Grid } from '../Grid';
import { MultiSearchProps } from '../search/HeroSearch';
import { Section } from '../Section';
import BuyerGuidePhoto from '../../images/KFH25-003-service-card-left.jpg';
import RentGuidePhoto from '../../images/KFH25-003-service-card-right.jpg';
import { Calculators } from '../calculators/Calculators';
import { Typography } from '../Typography';
import { Trustpilot } from '../Trustpilot';

interface LocationActionSectionTestProps {
  // name: string;
  // url: string;
  // isArea?: boolean;
  defaultMultisearch?: MultiSearchProps;
}

const StyledValuationBanner = styled(CTACard)`
  ${({ theme: { colors, media, maxMedia, space } }) => css`
    text-align: left;
    text-wrap: pretty;
    border: 1px solid ${colors.grey3.default};

    @media (min-width: ${media.lg}) {
      text-align: center;
    }

    a {
      text-decoration: none;
      color: ${colors.brand.default};
      display: flex;
      flex-direction: row-reverse;
      gap: 8px;

      @media (min-width: ${media.lg}) {
        flex-direction: row;
      }

      svg {
        path {
          fill: ${colors.brand.default};
        }
      }

      + span {
        color: ${colors.white.default};
      }

      &:last-child {
        @media (max-width: ${maxMedia.lg}) {
          border-top: 1px solid ${colors.grey3.default};
          padding-top: ${space.lg};
          margin-top: 24px;

          svg {
            display: none;
          }
        }
      }
    }

    > div {
      flex-grow: 0;
    }
  `};
`;

const StyledTypography = styled(Typography)`
  text-align: center;
`;

export const LocationActionSectionTest: FC<LocationActionSectionTestProps> = ({ defaultMultisearch }) => {
  const linkItems = [
    { text: 'Mortgages and Insurance', url: '/services/financial-services/', state: { fromSearchResults: true } },
    { text: 'Property Solicitors', url: '/services/property-solicitors/', state: { fromSearchResults: true } },
    {
      text: 'Survey and Professional Services',
      url: '/services/surveying-and-professional-services/',
      state: { fromSearchResults: true },
    },
    { text: 'See all our services', url: '/services', state: { fromSearchResults: true } },
  ];
  return (
    <>
      <Section contained>
        <StyledValuationBanner
          title="Specialist services at every stage of your property journey"
          tightSpacing
          linkItems={linkItems}
          backgroundColour="white"
        />
      </Section>
      <Section contained>
        <Grid desktopColumns="2">
          <ImageCard
            heading="Buyer guides"
            url="/buyers/the-buying-process/"
            intro="Everything you need to know about buying a property in London."
            actionLabel="View guides"
            image={BuyerGuidePhoto}
            key="imc-buyer-guides"
          />
          <ImageCard
            heading="Renting guides"
            url="/tenants/the-renting-process/"
            intro="Understand your rights and the processes involved in renting with our detailed tenants’ resources."
            actionLabel="View guides"
            image={RentGuidePhoto}
            key="imc-renting-guides"
          />
        </Grid>
      </Section>
      <Calculators
        stampDutyCalculator
        mortgageEstimatorCalculator
        leaseExtensionCalculator
        backgroundColour="grey"
        heading="Planning made easy with our calculators"
      />
      <Trustpilot />
    </>
  );
};
